const { __, sprintf } = wp.i18n;

// takes our saved options and transforms them into a format that plyr.io will use
export default function ({
  preset = {},
  chapters,
  branding,
  src,
  analytics,
  attributes = {},
  provider = "",
  video_id = 0,
  type,
  storage = {
    enabled: !prestoPlayer?.isAdmin,
    key: `presto-player-${preset.id}`,
  },
}) {
  const controlOptions = [
    "play-large",
    "rewind",
    "play",
    "fast-forward",
    "progress",
    "current-time",
    "mute",
    "volume",
    "captions",
    "settings",
    "pip",
    "fullscreen",
  ];

  const required = ["settings"];

  const disabled = [
    ...(["youtube", "vimeo"].includes(provider) ? ["pip"] : []),
    "captions",
  ];

  const controls = controlOptions.filter((key) => {
    return (preset?.[key] || required.includes(key)) && !disabled.includes(key);
  });

  if (["youtube", "vimeo"].includes(provider)) {
    delete controls.pip;
  }

  return wp.hooks.applyFilters("presto.playerSettings", {
    id: attributes?.id,
    title: attributes?.title || "",
    blockAttributes: {
      ...attributes,
      ...{ type },
    },
    vimeo: {
      sidedock: 0,
      controls: 0,
    },
    src,
    ajaxProgress: true,
    analytics,
    chapters,
    controls,
    settings: [
      "captions",
      "quality",
      "loop",
      ...(preset?.speed ? ["speed"] : []),
    ],
    hideControls: preset?.auto_hide,
    logo: branding?.logo,
    logo_width: branding?.logo_width,
    hide_logo: preset?.hide_logo,
    save_player_position: !!preset?.save_player_position,
    sticky_scroll: preset?.sticky_scroll,
    autoplay: attributes?.autoplay && !wp?.blocks ? true : false,
    playsInline: attributes?.playsInline && !wp?.blocks ? true : false,
    ...(provider ? { provider } : {}),
    ...(video_id ? { video_id } : {}),
    ...(attributes?.poster ? { poster: attributes.poster } : {}),
    invertTime: true,
    // debug: true,
    storage,
    // Localisation
    i18n: {
      restart: __("Restart", "presto-player"),
      rewind: __("Rewind {seektime}s", "presto-player"),
      play: __("Play", "presto-player"),
      pause: __("Pause", "presto-player"),
      fastForward: __("Forward {seektime}s", "presto-player"),
      seek: __("Seek", "presto-player"),
      seekLabel: sprintf(
        __("%1s of %2s", "presto-player"),
        "{currentTime}",
        "{duration}"
      ),
      played: __("Played", "presto-player"),
      buffered: __("Buffered", "presto-player"),
      currentTime: __("Current time", "presto-player"),
      duration: __("Duration", "presto-player"),
      volume: __("Volume", "presto-player"),
      mute: __("Mute", "presto-player"),
      unmute: __("Unmute", "presto-player"),
      enableCaptions: __("Enable captions", "presto-player"),
      disableCaptions: __("Disable captions", "presto-player"),
      download: __("Download", "presto-player"),
      enterFullscreen: __("Enter fullscreen", "presto-player"),
      exitFullscreen: __("Exit fullscreen", "presto-player"),
      frameTitle: __("Player for {title}", "presto-player"),
      captions: __("Captions", "presto-player"),
      settings: __("Settings", "presto-player"),
      pip: __("PIP", "presto-player"),
      menuBack: __("Go back to previous menu", "presto-player"),
      speed: __("Speed", "presto-player"),
      normal: __("Normal", "presto-player"),
      quality: __("Quality", "presto-player"),
      loop: __("Loop", "presto-player"),
      start: __("Start", "presto-player"),
      end: __("End", "presto-player"),
      all: __("All", "presto-player"),
      reset: __("Reset", "presto-player"),
      disabled: __("Disabled", "presto-player"),
      enabled: __("Enabled", "presto-player"),
      advertisement: __("Ad", "presto-player"),
      qualityBadge: {
        2160: __("4K", "presto-player"),
        1440: __("HD", "presto-player"),
        1080: __("HD", "presto-player"),
        720: __("HD", "presto-player"),
        576: __("SD", "presto-player"),
        480: __("SD", "presto-player"),
      },
    },
  });
}
